export default "__VITE_ASSET__jx5p2nJyF_X47WojhVH6OQ__"